exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".stepTow-tip[data-v-131d5667]{padding:3px 5px;background:#bceaff;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;color:#000;-ms-flex-pack:center;justify-content:center;margin-top:20px}.stepTow-tip i[data-v-131d5667]{color:#2d8cf0;font-size:26px;margin-right:5px}.stepTow-tip a[data-v-131d5667]{color:#2d8cf0;margin-left:5px}.content[data-v-131d5667]{width:800px;margin:50px auto 0}.stepThree-form[data-v-131d5667]{width:360px;margin:50px auto 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-131d5667&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/pc/stepThree.vue
// module id = 156
// module chunks = 0